/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import ErrorName from '../error/error-name';

/**
 * Sledovač čas.
 * @param {number} timeUs Čas, ve kterém dojde k resolvování Promise.
 * @param {GetNow} getNow Funkce, která zjistí aktuální čas.
 * @param {Object} [opts]
 * @param {AbortSignal} [opts.abortSignal] Signál pro předčasné přerušení.
 * @returns {Promise<void>} Nic
 */
function promisifyTimeWatcher(
  timeUs,
  getNow,
  { abortSignal = new AbortSignal() }
) {
  return new Promise((resolve, reject) => {
    let intervalId = -1;
    const abortMessage = 'waiting for specific time was aborted';
    const interval = 5;
    const checkTime = () => {
      const now = getNow();
      if (now >= timeUs) {
        clearInterval(intervalId);
        return resolve();
      }
    };

    const abortListener = () => {
      abortSignal.removeEventListener('abort', abortListener);
      const error = new Error(abortMessage);
      error.name = ErrorName.AbortError;
      clearInterval(intervalId);
      return reject(error);
    };

    abortSignal.addEventListener('abort', abortListener);
    intervalId = setInterval(checkTime, interval);
  });
}

/**
 * Funkce, která zjistí aktuální čas v mikrosekundách od UNIX epochy.
 * @name GetNow
 * @function
 * @returns {number} Čas od UNIX epochy v mikrosekundách.
 */

export default promisifyTimeWatcher;
